/**
 * Capitalises the first letter of a given string.
 */
export const capitaliseFirstLetter = (input) => {
    return input.charAt(0).toUpperCase() + input.slice(1);
};
//# sourceMappingURL=capitalise-first-letter.js.map